import logoImage from './assets/img/logo.png';
// import logoImage from './assets/img/logo-kari.png';
import headerImage from './assets/img/header.jpg';
// import headerImage from './assets/img/header-kari.jpg';
// import cartImage from './assets/img/kosar-kari.jpg';
import lastMinuteImage from './assets/img/last-minute.png';
import fontFamily from './assets/fonts/OpenSans-Regular.ttf';

(window as any).config = {
    uid: 'interfood',
    logoImage: logoImage,
    headerImage: headerImage,
    // cartImage: cartImage,
    cartImage: null,
    lastMinute: {
        text: 'A következő választékunk rendelhető a készlet erejéig (Fontos, hogy a Last minute során megrendelt ételek lemondására nincs lehetőség. Kérjük, fokozott figyelemmel adjanak le rendelést és válasszanak fizetési módot!): A betűjel végén szereplő „K” kis adagot jelöl. Szombati ételeink pénteken kerülnek kiszállításra.',
        image: lastMinuteImage
    },
    projectName: 'Interfood',
    projectSlogan: 'Frissen főzve, frissen hűtve',
    loginWelcome: 'Üdv újra a Interfood weblapján, kérem jelentkezzen be!',
    pdf: {
        fontFamily: fontFamily
    },
    constans: {
        CONST_URL_FOOLDAL: 'https://interfood.hu/',
        CONST_URL_GYIK: 'https://www.interfood.hu/gyakran-ismetelt-kerdesek/',
        CONST_URL_KAPCSOLAT: 'https://interfood.hu/kapcsolat/',
        CONST_URL_TUDNIVALOK: 'https://interfood.hu/tudnivalok/',
        CONST_URL_SZALLITASI_TERULETEK: 'https://interfood.hu/szallitasi-teruletek/',
        CONST_URL_ADATVEDELMI: 'https://interfood.hu/adatkezelesi-tajekoztato/',
        CONST_URL_ASZF: 'https://interfood.hu/altalanos-szerzodesi-feltetelek/'
    },
    urls: {
        prod: 'https://ia.interfood.hu',
        dev: 'https://interfood.dev.diff.hu',
        local: 'http://localhost:10001'
    },
    bugsnag: {
        api: 'b62e28fa441d74a5466cae0cc5644f67'
    },
    sentry: {
        dns: 'https://9095ef9c0d0938f0c462148aa84eca74@o1038507.ingest.us.sentry.io/4509009203101696'
    },
    payment_methods: ['cash', 'barion', 'mkb_szep_card', 'otp_szep_card', 'kh_szep_card', 'cib'],
    hasMultilingualMenu: false
};

import './variables.scss';
import('../../src/main')
    .then(module => {
        // The module is now loaded and executed
        console.log(`[${window.config?.uid ?? ''}] Main module loaded!`);
    })
    .catch(error => {
        console.error('❌ Error loading main module:', error);
    });
